import "@mdi/font/css/materialdesignicons.css";
import "vuetify/styles";

import { createVuetify } from "vuetify";
import {
  VBtn,
  VSelect,
  VTextField,
  VTextarea,
  VAutocomplete,
  VCombobox,
  VAlert,
} from "vuetify/components";

export default createVuetify({
  theme: {
    themes: {
      light: {
        colors: {
          primary: "#3C038C",
          "on-primary": "#FCFAFF",
          secondary: "#E34696",
          "on-secondary": "#FEFBFC",
          error: "#930009",
          "on-error": "#FFFAFA",
          "on-success": "#FCFDFC",
          background: "#FDFCFC",
          "on-background": "#1F141A",
          "on-background-variant": "#4A3D5C",
          outline: "#7B6699",
          "outline-variant": "#CAC2D6",
          "on-outline-variant": "#EBE0E6",
          // New branding below
          "purple-1": "#36027A",
          "purple-4": "#6516DF",
          "purple-5": "#902FFC",
          "purple-6": "#AC7CF8",
          "purple-8": "#D2B6FE",
          "purple-9": "#DFC9FF",
          warning: "#FE7463",
          "pink-4": "#D2B6FE",
          "pink-5": "#EBE0FC",
          black: "#222222",
          grey: "#838383",
          success: "#328F7C",
        },
      },
    },
  },
  aliases: {
    VBtnVar: VBtn,
    VBtnNd: VBtn,
    YBtn: VBtn,
    YBtnNd: VBtn,
    YTextField: VTextField,
    YTextarea: VTextarea,
    YSelect: VSelect,
    YAutocomplete: VAutocomplete,
    YCombobox: VCombobox,
    YAlert: VAlert,
  },
  defaults: {
    VBtn: {
      color: "primary",
      size: "large",
      rounded: "sm",
    },
    VBtnVar: {
      color: "background",
      class: "text-primary",
      size: "large",
      rounded: "sm",
    },
    VBtnNd: {
      color: "secondary",
      size: "large",
      rounded: "sm",
      variant: "outlined",
    },
    YBtn: {
      color: "purple-4",
      size: "large",
      rounded: "lg",
      elevation: 0,
    },
    YBtnNd: {
      color: "purple-4",
      size: "large",
      rounded: "lg",
      variant: "outlined",
      elevation: 0,
    },
    YTextField: {
      color: "purple-4",
      density: "comfortable",
      rounded: "lg",
      variant: "outlined",
      class: "y-bg-white",
    },
    YTextarea: {
      color: "purple-4",
      density: "comfortable",
      rounded: "lg",
      variant: "outlined",
      class: "y-bg-white",
      noResize: true,
      clearable: true,
    },
    YSelect: {
      color: "purple-4",
      density: "comfortable",
      rounded: "lg",
      variant: "outlined",
      class: "y-bg-white",
    },
    YAutocomplete: {
      color: "purple-4",
      density: "comfortable",
      rounded: "lg",
      variant: "outlined",
      class: "y-bg-white",
    },
    YCombobox: {
      color: "purple-4",
      density: "comfortable",
      rounded: "lg",
      variant: "outlined",
      class: "y-bg-white",
    },
    VSkeletonLoader: {
      color: "background",
    },
    VDataTable: {
      style: "background-color: rgb(var(--v-theme-background));",
    },
    VTable: {
      style: "background-color: rgb(var(--v-theme-background));",
    },
    VExpansionPanel: {
      style: "background-color: rgb(var(--v-theme-background));",
    },
    YAlert: {
      density: "comfortable",
      outlined: true,
      class: "m-4 pa-4 border-opacity-100",
      variant: "outlined",
      border: "start",
    },
  },
});
